
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-110.002 -55.001 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M345.259 187.909c-6.788-6.789-15.027-10.18-24.729-10.18H308.9v-69.822c0-44.606-15.997-82.905-47.998-114.906-32-32.001-70.295-48.002-114.906-48.002-44.61 0-82.914 16-114.91 48.001C-.916 25.001-16.912 63.299-16.912 107.907v69.822h-11.634c-9.693 0-17.938 3.392-24.727 10.18-6.789 6.783-10.182 15.028-10.182 24.73v209.452c0 9.694 3.395 17.94 10.182 24.73 6.789 6.782 15.033 10.178 24.727 10.178h349.083c9.702 0 17.94-3.392 24.731-10.178 6.781-6.79 10.182-15.036 10.182-24.73V212.635c.005-9.696-3.4-17.938-10.191-24.726zm-106.175-10.18H52.907v-69.822c0-25.696 9.092-47.637 27.274-65.816C98.365 23.91 120.302 14.821 146 14.821c25.702 0 47.632 9.088 65.818 27.27 18.177 18.177 27.266 40.12 27.266 65.816v69.822z"}})])
          )
        }
      }
    